import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

const ChartContainer = styled(Box)(({ theme }) => ({
  height: 200,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const LegendContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  gap: theme.spacing(2),
  marginTop: theme.spacing(1),
}));

const LegendItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
}));

const LegendColor = styled(Box)<{ color: string }>(({ theme, color }) => ({
  width: 12,
  height: 12,
  borderRadius: '50%',
  backgroundColor: color,
}));

const LegendText = styled(Typography)(({ theme }) => ({
  fontSize: '0.75rem',
  color: '#4A5568',
}));

const UserFeedback: React.FC = () => {
  const data = [
    { name: 'Positive', value: 85, color: '#6B46C1' },
    { name: 'Negative', value: 15, color: '#E2E8F0' },
  ];

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 600, color: '#1A202C', mb: 2 }}>
        User Feedback
      </Typography>
      <ChartContainer>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={40}
              outerRadius={80}
              paddingAngle={0}
              dataKey="value"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </ChartContainer>
      <LegendContainer>
        {data.map((item, index) => (
          <LegendItem key={index}>
            <LegendColor color={item.color} />
            <LegendText>{item.name}</LegendText>
          </LegendItem>
        ))}
      </LegendContainer>
    </Box>
  );
};

export default UserFeedback; 